/** True when the user has entered a value (including explicit "0"). */
export function isFieldEntered(value: string | number | null | undefined): boolean {
  if (value === null || value === undefined) return false
  return String(value).trim() !== ''
}

export function parseIntField(value: string | number | null | undefined): number {
  const s = String(value ?? '').trim()
  if (s === '') return 0
  const n = parseInt(s, 10)
  return Number.isFinite(n) ? n : 0
}

export function parseAgeField(value: string | number | null | undefined): number | null {
  const s = String(value ?? '').trim()
  if (s === '') return null
  const n = Number(s)
  if (!Number.isFinite(n) || n < 17 || n > 70) return null
  return n
}

export const SCORING_FIELD_PLACEHOLDER = '—'